<template>
  <div>
    <Row>
      <Form ref="queryChargeRuleForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <Form-item :label-width="0">
              <Input
                v-model="query.ruleName"
                placeholder="请输入收费规则名称"
                style="width:150px;margin-right: 10px;"
              />
              <Input
                v-model="query.ruleCode"
                placeholder="请输入收费规则唯一标识码"
                style="width:170px;margin-right: 10px;"
              />
          <Select v-model="query.ruleType" style="width: 200px" class="tool-item" placeholder="收费规则类型">
            <Option
              v-for="item in dict.rule_type"
              :value="item.dictKey"
              :key="item.dictValue"
            >
              {{ item.dictValue }}
            </Option>
          </Select>
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openChargeRuleDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="chargeRuleTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
        <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.chargeRuleTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div>
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="chargeRuleDrawer" :title="this.$t('drawer.title')[chargeRuleDrawer.type]" :visible.sync="chargeRuleDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <chargeRule-form ref="chargeRuleForm"/>
        <div class="right-drawer__footer" v-if="chargeRuleDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="chargeRuleDrawer.submiting">{{ chargeRuleDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="chargeRuleDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import ChargeRuleForm from '@/views/travel/charge-rule/components/Form.vue';
Vue.component('chargeRule-form', ChargeRuleForm);

export default {
  dictParams: ['rule_type','car_type', 'status'],
  name: 'aip-travel-chargeRule-index',
  mixins:[mixin],
  data () {
    return {
      query:{
        ruleName: '',
        ruleCode: '',
        ruleType: '',
        ruleDetail: '',
        dayMaxFee: '',
        dayMaxStatus: '',
        carType: '',
        status: '',
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      chargeRuleDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  methods: {
    handleBatchOperate(){
      let records = this.$refs.chargeRuleTable.getSelection()
      console.log(records)
      if (records.length == 0) {
        this.$Message.warning(this.$t('errorText'))
        return;
      }
      this[this.batchOperate.action](records)
    },
    handleSearch(){
      this.page.loading = true;
      //console.log(this.query);
      api.travel.ChargeRule.query(this.query,this.page)
        .then(data=>{
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openChargeRuleDrawer(chargeRule){
      this.chargeRuleDrawer.visible = true
      this.chargeRuleDrawer.type = chargeRule ? chargeRule.type : 'add'
      this.$nextTick(()=>{
          if(chargeRule){
              this.$refs['chargeRuleForm'].getChargeRule(chargeRule.id,chargeRule.type)
          }else{
            this.$refs['chargeRuleForm'].handleReset()
          }
      })
    },
    handleSubmit(){
        this.chargeRuleDrawer.submiting = true;
        this.$refs.chargeRuleForm.handleSubmit(
          data=>{
            this.chargeRuleDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.chargeRuleDrawer.visible=false, 1000);
          },
          ()=>{
            this.chargeRuleDrawer.submiting = false;
          }
        )
    },
    deleteChargeRule(id){
      api.travel.ChargeRule.remove(id)
                            .then(response=> {
                              if (response.code==200){
                                this.$Message.success(response.msg);
                              }else {
                                this.$Message.error(response.msg);
                              }
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.travel.ChargeRule.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    }
  },
  computed: {
    columns () {
      return [
          {key: 'id', width: 60, fixed:'left',type:'selection'},
          {key: 'ruleName', align:'left',width: 150,fixed:'left', title:  this.$t('travel.charge-rule.ruleName.label')},
          {key: 'ruleCode', align:'left',width: 150, title:  this.$t('travel.charge-rule.ruleCode.label')},
        {
          key: 'ruleType',
          align: 'left',
          width: 120,
          filters: this.dict.rule_type,
          filterMultiple: false,
          title: this.$t('travel.charge-rule.ruleType.label'),
          render: (h, params) => {
            return <div>{params.column.filters.find(t => params.row.ruleType == t.dictKey).dictValue}</div>
          }
        },
          {key: 'ruleDetail', align:'left',minWidth: 120, title:  this.$t('travel.charge-rule.ruleDetail.label')},
          // {key: 'dayMaxFee', align:'left',width: 100, title:  this.$t('travel.charge-rule.dayMaxFee.label')},
          // {key: 'dayMaxStatus', align:'left',width: 100, title:  this.$t('travel.charge-rule.dayMaxStatus.label')},
        {
          key: 'carType',
          align: 'left',
          width: 120,
          filters: this.dict.car_type,
          filterMultiple: false,
          title: this.$t('travel.charge-rule.carType.label'),
          render: (h, params) => {
            return <div>{params.column.filters.find(t => params.row.carType == t.dictKey).dictValue}</div>
          }
        },
        {
          key: 'status',
          align: 'left',
          width: 120,
          filters: this.dict.status,
          filterMultiple: false,
          title: this.$t('travel.charge-rule.status.label'),
          render: (h, params,disable) => {
            disable = false;
            if (params.row.status == 1){
              disable = true;
            }
            return  <div>
              <i-switch disabled={disable} value={
                params.row.status?true:false
              } onOn-change={(v)=>{
                v=v?1:0;
                api.travel.ChargeRule.changeDefaultFlag(params.row.id,v).then(e=>{
                  if (e.code == 200) {
                    this.$Message.success(e.msg);
                  } else {
                    this.$Message.error(e.msg)
                  }
                  this.handleSearch()
                })}
              }>
              </i-switch>
            </div>
          }
        },
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 140,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openChargeRuleDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openChargeRuleDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true} onOn-ok={()=>this.deleteChargeRule(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>
